var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144 376C113.072 376 88 401.072 88 432S113.072 488 144 488S200 462.928 200 432S174.928 376 144 376ZM201.344 32H112C50.25 32 0 82.25 0 144C0 170.516 21.5 192 48 192S96 170.516 96 144C96 135.172 103.188 128 112 128H201.344C213.844 128 224 138.172 224 150.672C224 158.844 219.562 166.422 212.438 170.438L120.469 222.172C105.344 230.672 96 246.656 96 264V288C96 314.516 117.5 336 144 336C169.094 336 189.719 316.734 191.812 292.172L259.5 254.094C296.812 233.109 320 193.484 320 150.672C320 85.234 266.781 32 201.344 32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.b7084291f5cc772cac2905f6b4e078c9.svg";
export { ForwardRef as ReactComponent };